import { render, staticRenderFns } from "./WarehouseTabPurchase.vue?vue&type=template&id=3740f97a&scoped=true"
import script from "./WarehouseTabPurchase.vue?vue&type=script&lang=js"
export * from "./WarehouseTabPurchase.vue?vue&type=script&lang=js"
import style0 from "./WarehouseTabPurchase.vue?vue&type=style&index=0&id=3740f97a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3740f97a",
  null
  
)

export default component.exports